import React, { useEffect, useState } from 'react';
import { Loading } from '../components/loading/Loading';
import { useQueryConfigs } from '../queries/config/hooks/useQueryConfigs';

export const AppendStyles: React.FC = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const { data } = useQueryConfigs();

  useEffect(() => {
    if (data?.configs?.styling) {
      // @ts-ignore
      window.tz_globalConfigs = {
        ...window.tz_globalConfigs,
        styling: {
          ...data.configs.styling,
        },
      };
      setIsLoading(false);
    }
  }, [data]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      {children}
    </>
  );
};
